import { useEffect, useState } from 'react'

import { getStripeCardStyle } from '../utils/getStripeCardStyle'

export const useStripeElement = (
  elementType: stripe.elements.elementsType,
  elements?: stripe.elements.Elements,
  options: stripe.elements.ElementsOptions = {},
) => {
  const [element, setElement] = useState<stripe.elements.Element>()
  const [error, setError] = useState<string>()
  const [isComplete, setIsComplete] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const [isMounted, setIsMounted] = useState(false)

  const handleElementChange = (response: stripe.elements.ElementChangeResponse | undefined) => {
    setError(response?.error?.message)
    setIsComplete(!!response?.complete)
  }

  const handleElementReady = () => {
    setError(undefined)
  }

  const initializeElement = () => {
    if (!elements) {
      return
    }
    const elementInstance = elements.create(elementType, {
      style: getStripeCardStyle(),
      ...options,
    })

    elementInstance.on('change', handleElementChange)
    elementInstance.on('ready', handleElementReady)
    elementInstance.on('focus', () => setIsFocused(true))
    elementInstance.on('blur', () => setIsFocused(false))

    setElement(elementInstance)
  }

  const mountElement = (node: HTMLDivElement) => {
    if (!element) {
      return
    }

    setIsMounted(true)
    element.mount(node)
  }

  const unmountElement = () => {
    if (!element) {
      return
    }

    setIsMounted(false)
    element.unmount()
  }

  useEffect(() => {
    initializeElement()
  }, [elements])

  return {
    element,
    error,
    isInitialized: !!element,
    isComplete,
    isFocused,
    isMounted,
    setError,
    mountElement,
    unmountElement,
  }
}
